export default __webpack_public_path__ + "images/logos/logo-header.svg?7c2d550c3c7d7f3d70eecc7dd4e3595e33c69d795c1a52792b2455c395e2f735";